// extracted by mini-css-extract-plugin
module.exports = {"container":"GenericCard_container__128aj","heading":"GenericCard_heading__3rN0L"};